/*!
 Current file is based on ngToast (http://tamerayd.in/ngToast/) implementation and will be work derived from ngToast library release under the MIT license below:

 The MIT License (MIT)
 Copyright &copy; 2016 Tamer Aydin, http://tamerayd.in

 Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
 to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense,
 and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

//(function (window, angular) {
	'use strict';

	angular.module("appToast.directives").run(appToastTemplates);
	angular.module("appToast.directives").directive('toast', appToastDirective);
	angular.module("appToast.directives").directive('toastMessage', appToastMessageDirective);

	/** @ngInject */
	function appToastTemplates($templateCache) {
		$templateCache.put('appToast/toast.html',
			'<div class="ert-toast ert-toast--{{hPos}} ert-toast--{{vPos}} {{animation ? \'ert-toast--animate-\' + animation : \'\'}}">' +
			'<ul class="ert-toast__list">' +
			'<toast-message ng-repeat="message in messages" ' +
			'message="message" count="message.count">' +
			'<span ng-bind-html="message.content"></span>' +
			'</toast-message>' +
			'</ul>' +
			'</div>');
		$templateCache.put('appToast/toastMessage.html',
			'<li class="ert-toast__message {{message.additionalClasses}}"' +
			'ng-mouseenter="onMouseEnter()"' +
			'ng-mouseleave="onMouseLeave()">' +
			'<div class="alert alert-{{message.className}}" ' +
			'ng-class="{\'alert-dismissible\': message.dismissButton, \'alert-animation-bounce\': message.bounce}">' +
			'<span class="icon icon-alert-{{message.className}}"></span>' +
			'<button type="button" class="close" ' +
			'ng-if="message.dismissButton" ' +
			'ng-bind-html="message.dismissButtonHtml" ' +
			'ng-click="!message.dismissOnClick && dismiss()">' +
			'</button>' +
			'<span ng-if="count" class="ert-toast__message__count">' +
			'{{count + 1}}' +
			'</span>' +
			'<span ng-if="!message.compileContent" ng-transclude></span>' +
			'<div ng-if="message.showTimestamp || message.className === \'danger\'" class="ert-toast__timestamp">{{message.timestamp}}</div>' +
			'</div>' +
			'</li>');
	}

	/** @ngInject */
	function appToastDirective(appToast, $templateCache, $log) {
		return {
			replace: true,
			restrict: 'EA',
			templateUrl: 'appToast/toast.html',
			compile: function (tElem, tAttrs) {
				if (tAttrs.template) {
					var template = $templateCache.get(tAttrs.template);
					if (template) {
						tElem.replaceWith(template);
					} else {
						$log.warn('appToast: Provided template could not be loaded. ' +
							'Please be sure that it is populated before the <toast> element is represented.');
					}
				}

				return function (scope) {
					scope.hPos = appToast.settings.horizontalPosition;
					scope.vPos = appToast.settings.verticalPosition;
					scope.animation = appToast.settings.animation;
					scope.messages = appToast.messages;
				};
			}
		};
	}

	/** @ngInject */
	function appToastMessageDirective($timeout, $compile, appToast) {
		return {
			replace: true,
			transclude: true,
			restrict: 'EA',
			scope: {
				message: '=',
				count: '='
			},
			controller: ['$scope', 'appToast', function ($scope, appToast) {
				$scope.dismiss = function () {
					appToast.dismiss($scope.message.id);
				};
			}],
			templateUrl: 'appToast/toastMessage.html',
			link: function (scope, element, attrs, ctrl, transclude) {
				element.attr('data-message-id', scope.message.id);

				var dismissTimeout;
				var scopeToBind = scope.message.compileContent;

				scope.cancelTimeout = function () {
					$timeout.cancel(dismissTimeout);
				};

				scope.startTimeout = function () {
					if (scope.message.dismissOnTimeout) {
						dismissTimeout = $timeout(function () {
							appToast.dismiss(scope.message.id);
						}, scope.message.timeout);
					}
				};

				scope.onMouseEnter = function () {
					scope.cancelTimeout();
				};

				scope.onMouseLeave = function () {
					scope.startTimeout();
				};

				if (scopeToBind) {
					var transcludedEl;

					transclude(scope, function (clone) {
						transcludedEl = clone;
						element.children().append(transcludedEl);
					});

					$timeout(function () {
						$compile(transcludedEl.contents())
						(typeof scopeToBind === 'boolean' ?
							scope.$parent : scopeToBind, function (compiledClone) {
							transcludedEl.replaceWith(compiledClone);
						});
					}, 0);
				}

				scope.startTimeout();

				if (scope.message.dismissOnClick) {
					element.bind('click', function () {
						appToast.dismiss(scope.message.id);
						scope.$apply();
					});
				}

				if (scope.message.onDismiss) {
					scope.$on('$destroy',
						scope.message.onDismiss.bind(scope.message));
				}
			}
		};
	}

//})(window, window.angular);
